/**
 * CONN-PROBE-3 — indicador COMPACTO de conectividade (L·I·D) para linhas de
 * tabela/lista e popup de mapa. Observabilidade apenas; contrato tipado `conn`.
 *
 * Mostra 3 letras (L=rede local, I=internet, D=DNS), cada uma colorida pelo
 * estado do alvo — cor + LETRA (não depende só de cor) + tooltip por alvo.
 * Device sem probe → "—" discreto.
 */
import { connProbeView, stateLabel, stateTextClass } from "../lib/connProbe.js";

export default function ConnProbeChip({ conn, connSupported }) {
  const v = connProbeView(conn, connSupported);
  if (!v.supported) {
    return (
      <span className="text-noc-faint" title="Sem diagnóstico de conectividade">
        —
      </span>
    );
  }
  const dot = (view, letter, name) => (
    <span
      className={`cursor-help ${stateTextClass(view.state)}`}
      title={`${name}: ${stateLabel(view.state)}${view.rtt ? ` (${view.rtt})` : ""}`}
    >
      {letter}
    </span>
  );
  return (
    <span
      className="font-mono text-[11px] tracking-[0.15em]"
      aria-label={`Conectividade — Rede local ${stateLabel(v.lan.state)}, Internet ${stateLabel(
        v.inet.state,
      )}, DNS ${stateLabel(v.dns.state)}`}
    >
      {dot(v.lan, "L", "Rede local")}
      {dot(v.inet, "I", "Internet")}
      {dot(v.dns, "D", "DNS")}
    </span>
  );
}
